import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';

@Component({
  selector: 'app-button-delete-job',
  templateUrl: './button-delete-job.component.html',
  styleUrls: ['./button-delete-job.component.scss']
})
export class ButtonDeleteJobComponent implements OnInit {
  @Input()
  text = 'button'

  @Input()
  outline = false

  @Input()
  leftIconPath = null

  @Input()
  leftIconSecondaryPath = null

  @Input()
  rightIconPath = null

  @Input()
  rightIconSecondaryPath = null

  @Input()
  size = 'md'

  @Input()
  selectMenuClick = ''

  @Output() click = new EventEmitter()

  isHover = false

  constructor() { }

  _onHover(status) {
    this.isHover = status
  }

  _onClick(event) {
    this.click.emit(event)
  }

  ngOnInit() {
  }
}
